import { environment } from "../../environments/environment";

export const STOP_BILL_FEATURE_ENABLED: boolean = true;

export const serviceJobIdRecallFlag = true;

export const FlagCeEnabled: boolean = true

export const isHotjarScriptEnabled: boolean = true;
export const FlagCxOneEnabled: boolean = false;//environment.env === 'prod' ? false : true;
export const DASHBOARD_SOCIALLINKS_FLAG: boolean = false;

export const PAZE_ENABLED: boolean = true;
export const FFS_ENABLED: boolean = true;
export const PAZE_REPLACEMENT_DEDUCTIBLE_FLAG: boolean = true;

export const SP_COMPETE_ENABLED = true;
/**
 * TODO: Phased rollout plan for PROCURE_VENDOR_ENABLED:
 * - Enabled in all environments except 'prod' for initial validation and monitoring.
 * - Rationale: Keeping disabled in prod allows for staged feature validation, risk mitigation, and fallback flow verification.
 * - Update this flag and PR description once production enablement criteria are met.
 */
export const PROCURE_VENDOR_ENABLED = true;
export const ROOF_LEAK_ENABLED = true;
// cross sell enrollment with CE, surge  feature flag
export const CROSS_SELL_ENABLED = true;
// Made cc turn off for Testing in QA environment
export const MADE_CREDIT_CARD_ENABLED = true;
// showRealEstate Banner
export const RE_RENEWAL_BANNER_ENABLED = true;
// Controls whether the inline recall modal is shown on the what-is-issue page
export const RECALL_WHAT_IS_ISSUE_MODAL_ENABLED: boolean = false;
// Controls whether the Remax logo is applied based on logoId
export const REMAX_LOGO_ENABLED: boolean = false;
export const APOSP_CANCEL_BUTTON_ENABLED: boolean = false;
// RE modal feature flag
export const RE_MODAL_CONFIRM_CONTACT_ENABLED: boolean = true;
// Appliance buyline feature flag
export const NEW_APPLIANCE_BUYLINE_ENABLED: boolean = true;
